"use client";
import React, { useState } from "react";
import { EMOJI_CATEGORIES } from "@/app/utils/emoji";
import styles from "./EmojiPanel.module.scss";

import Emoji1 from "@/app/icons/emoji1.svg";
import Emoji2 from "@/app/icons/emoji2.svg";
import Emoji3 from "@/app/icons/emoji3.svg";
import Emoji4 from "@/app/icons/emoji4.svg";
import Emoji5 from "@/app/icons/emoji5.svg";
import Locale from "@/app/locales";

interface EmojiPanelProps {
  onEmojiSelect: (emoji: string) => void;
  isVisible: boolean;
  onClose: () => void;
}

export default function EmojiPanel({
  onEmojiSelect,
  isVisible,
  onClose,
}: EmojiPanelProps) {
  const [activeCategory, setActiveCategory] = useState("SMILEYS");

  if (!isVisible) return null;

  const handleEmojiClick = (emoji: string) => {
    onEmojiSelect(emoji);
    onClose(); // 选择表情后关闭面板
  };

  const categoryKeys = Object.keys(EMOJI_CATEGORIES) as Array<
    keyof typeof EMOJI_CATEGORIES
  >;

  return (
    <div className={styles.emojiPanel}>
      <div className={styles.overlay} onClick={onClose} />
      <div className={styles.panelContent}>
        {/* 头部 */}
        <div className={styles.header}>
          <span className={styles.title}>{Locale.chatInput.selectEmoji}</span>
          <button className={styles.closeBtn} onClick={onClose}>
            ✕
          </button>
        </div>

        {/* 分类标签 */}
        <div className={styles.categoryTabs}>
          {categoryKeys.map((categoryKey) => (
            <button
              key={categoryKey}
              className={`${styles.categoryTab} ${
                activeCategory === categoryKey ? styles.active : ""
              }`}
              onClick={() => setActiveCategory(categoryKey)}
            >
              {/* 这里可以根据不同分类使用不同的图标 */}
              {categoryKey === "SMILEYS" && <Emoji1 />}
              {categoryKey === "ANIMALS" && <Emoji2 />}
              {categoryKey === "FOOD" && <Emoji3 />}
              {categoryKey === "ACTIVITIES" && <Emoji4 />}
              {categoryKey === "SYMBOLS" && <Emoji5 />}
              {/* 其他分类图标可以继续添加 */}
            </button>
          ))}
        </div>

        {/* 表情网格 */}
        <div className={styles.emojiGrid}>
          {EMOJI_CATEGORIES[
            activeCategory as keyof typeof EMOJI_CATEGORIES
          ].emojis.map((emoji, index) => (
            <button
              key={`${emoji}-${index}`}
              className={styles.emojiItem}
              onClick={() => handleEmojiClick(emoji)}
              title={emoji}
            >
              {emoji}
            </button>
          ))}
        </div>

        {/* 最近使用的表情 (可选功能) */}
        <div className={styles.recentSection}>
          <div className={styles.sectionTitle}>
            {Locale.chatInput.recentlyUse}
          </div>
          <div className={styles.recentEmojis}>
            {/* 这里可以显示最近使用的表情，暂时显示常用的 */}
            {["😀", "😂", "😍", "👍", "❤️", "😊", "😭", "🤔"].map(
              (emoji, index) => (
                <button
                  key={`recent-${emoji}-${index}`}
                  className={styles.emojiItem}
                  onClick={() => handleEmojiClick(emoji)}
                  title={emoji}
                >
                  {emoji}
                </button>
              ),
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
